export class Command<T extends (...args: any) => any = (...args: any) => any> {
  cbs = new Map<string, T>()
  get keys() {
    return [...this.cbs.keys()]
  }
  runByKeys(ids: string[], ...args) {
    const results: ReturnType<T>[] = []
    ids.forEach((id) => {
      const cb = this.cbs.get(id)
      const result: ReturnType<T> = cb?.(...args)
      results.push(result)
    })
    return results
  }
  runByPatternsOrKeys(patterns: string[], ...args) {
    const ids = this.keys.filter((key) => {
      const reg = new RegExp(patterns.join("|"))
      return reg.test(key)
    })
    return this.runByKeys(ids, ...args)
  }
  run(...args) {
    return this.runByKeys(this.keys, ...args)
  }
  push(id: string, cb: T) {
    this.cbs.set(id, cb)
  }
  remove(id: string) {
    this.cbs.delete(id)
  }
  clean() {
    this.cbs.clear()
  }
}
